module.exports = __webpack_public_path__ + "static/media/angola.a78fbd22.svg";